package one.healthium.update_food_preferences.domain.models

data class FoodPreferencesCategoryModel(
    val id: String,
    val description: String,
    val availableStatuses: List<FoodPreferenceStatus>,
    val options: List<FoodPreferenceItemModel>,
)
